<template>



    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">







        <CRow class="justify-content-md-center">
            <CCol sm="6">
                <CCard>
                    <form v-on:submit.prevent="saveForm()">

                    <CCardHeader>
                        <strong>اطلاعات تماس جدید </strong>
<!--                        <div class="card-header-actions">-->
<!--                            <a-->
<!--                                    href="#"-->
<!--                                    class="card-header-action"-->
<!--                                    rel="noreferrer noopener"-->
<!--                                    target="_blank"-->
<!--                            >-->
<!--                                <small class="text-muted">خروجی اکسل</small>-->
<!--                            </a>-->
<!--                        </div>-->
                    </CCardHeader>
                    <CCardBody>


                        <CRow>
                            <CCol sm="6">
                                <CInput
                                        v-model="item.first_name"
                                        label="نام"
                                        placeholder=""
                                />
                            </CCol>
                            <CCol sm="6">
                                <CInput
                                        v-model="item.last_name"
                                        label=" نام خانوادگی"
                                        placeholder=""
                                />
                            </CCol>

                        </CRow>


                        <CRow>
                            <CCol sm="6">
                                <CInput
                                        v-model="item.mobile"
                                        label="موبایل (اصلی)"
                                        type="number"
                                        placeholder=""
                                        valid-feedback="فرمت شماره تلفن درست است"
                                        invalid-feedback="فرمت شماره تلفن صحیح نمی باشد"
                                        :is-valid="validatorMobile"
                                />
                            </CCol>

                            <CCol sm="6">
                                <CInput
                                        v-model.number="item.tell"
                                        label="تلفن/فکس (اصلی)"
                                        placeholder=""
                                        valid-feedback="فرمت شماره تلفن درست است"
                                        invalid-feedback="فرمت شماره تلفن صحیح نمی باشد"
                                        :is-valid="validatorTell"
                                />
                            </CCol>
                        </CRow>


                        <CRow>
                            <CCol sm="6">
                                <CInput
                                        v-model="item.email"
                                        label="ایمیل"
                                        type="email"
                                        placeholder=""
                                />
                            </CCol>
                            <CCol sm="6">

                                <label class="control-label">شهر</label>
                                <v-select
                                        v-model="item.city"
                                        :options="cities"></v-select>

<!--                                <v-select :options="cities" label="title" >-->
<!--                                    <template #search="{tags}">-->
<!--                                        <input-->
<!--                                                class="vs__search"-->
<!--                                                :required="!selected"-->
<!--                                                v-bind="tags"-->
<!--                                        />-->
<!--                                    </template>-->
<!--                                </v-select>-->








                            </CCol>

                        </CRow>
                        <CRow>
                            <CCol sm="12">
                                <CInput
                                        v-model="item.address"
                                        label="آدرس"
                                        placeholder=""
                                />
                            </CCol>

                        </CRow>




                        <CRow>
                            <CCol sm="6"
                            >

                                <label class="control-label">نوع  </label>
                                <select class="form-control" v-model="item.type ">
                                    <option value="1">سرنخ </option>
                                    <option value="2">فرصت </option>
                                    <option value="3" style="font-weight: bold">{{$client}} </option>
                                    <option value="4" style="font-weight: bold">تامین کننده </option>
                                    <option value="5">همکار/پیمانکار </option>
                                    <option value="0">نامشخص </option>

                                </select>
                            </CCol>



                            <CCol sm="6" class="pt-4">
                                <b-btn @click="showLegalItems = !showLegalItems">
                                    سایر آیتم ها
                                </b-btn>
                                <b-btn @click="showTrackingItems = !showTrackingItems">
                                     آیتم های پیگیری
                                </b-btn>
                            </CCol>

                        </CRow>











                        <CRow v-if="showLegalItems" style="background-color: #E8E9EC" class="my-4 py-2">

<!--                            post_code: '', other_info:'',-->


                            <CCol sm="6"
                            >
                                <label class="control-label">حقیقی / حقوقی </label>
                                <select class="form-control" v-model="item.legal">
                                    <option value="1">حقیقی </option>
                                    <option value="2">حقوقی </option>


                                </select>
                            </CCol>
                            <CCol sm="6">
                                <CInput
                                        v-model="item.company"
                                        label="شرکت"
                                        placeholder=""
                                />
                            </CCol>

                            <CCol sm="6">
                                <CInput
                                        v-model="item.brand"
                                        label="برند"
                                        placeholder=""
                                />
                            </CCol>
                            <CCol sm="6">
                                <CInput
                                        v-model="item.web"
                                        label="سایت / پیج"
                                        placeholder=""
                                />
                            </CCol>


                            <CCol sm="6">
                                <CInput
                                        v-model="item.national_code"
                                        label="کد‌ملی / شناسه‌ملی"
                                        placeholder=""
                                />
                            </CCol>
                            <CCol sm="6">
                                <CInput
                                        v-model="item.economic_code"
                                        label="کد اقتصادی"
                                        placeholder=""
                                />
                            </CCol>

                        </CRow >







                        <CRow v-if="showTrackingItems">



                            <CCol sm="6">

                                <CInput
                                        v-model="item.source"
                                        label="منبع"
                                        placeholder="تلفن، سایت، اینستاگرام و ..."
                                />
                            </CCol>

                            <CCol sm="6">

                                <label class="control-label">وضعیت پیگیری </label>
                                <select class="form-control" v-model="item.status ">
                                    <option value="0">نامشخص </option>
                                    <option value="1">نیاز به بررسی از سمت {{$client}} </option>
                                    <option value="2">تعیین قرار تلفنی بعدی </option>
                                    <option value="3">تعیین قرار حضوری بعدی </option>
                                    <option value="4">پیگیری از طریق پیام رسان </option>
                                    <option value="5">ارسال پروپوزال </option>
                                    <option value="6">ارسال پیش فاکتور </option>
                                    <option value="7">عدم همکاری </option>
                                </select>
                            </CCol>

                            <CCol sm="12" v-if="disableAppointmentTime()">
                                <label class="control-label">تاریخ قرار/تماس بعد </label>
                                <custom-time-picker  v-model="item.next_appointment" :disabled="!disableAppointmentTime()"
                                                     type="datetime" :clearable="true" placeholder="تاریخ را انتخاب کنید " min="" max="">
                                </custom-time-picker>


                            </CCol>


                            <CCol sm="6">
                                <CInput
                                        v-model="item.code"
                                        label="کد رابط مالی"
                                        placeholder="کد حسابداری"
                                />

                            </CCol>
                            <CCol sm="6">
                                <CTextarea
                                        v-model="item.appointment_note"
                                        label="یادداشت"
                                        placeholder=""
                                        row="1"
                                ></CTextarea>

                            </CCol>

                        </CRow>







                    </CCardBody>


                    <CCardFooter>
                        <CButton type="submit" size="sm" color="success"><CIcon name="cil-check-circle"/> ثبت</CButton>
<!--                        <CButton type="reset" size="sm" color="danger"><CIcon name="cil-ban"/> Reset</CButton>-->
                    </CCardFooter>
                    </form>


                </CCard>
            </CCol>

        </CRow>












<!--


        <CRow>
            <CCol md="6">
                <CCard>
                    <CCardHeader>
                        Use the grid for big devices! <small><code>.col-lg-*</code> <code>.col-md-*</code> <code>.col-sm-*</code></small>
                    </CCardHeader>
                    <CCardBody>
                        <CRow
                                class="form-group"
                                v-for="(number, key) in [4,5,6,7,8]"
                                :key="key"
                        >
                            <CCol :col="12 - number">
                                <CInput class="mb-0" :placeholder="`.col-md-${12 - number}`"/>
                            </CCol>
                            <CCol :col="number">
                                <CInput class="mb-0" :placeholder="`.col-md-${number}`"/>
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                        <CButton size="sm" color="primary">Action</CButton>
                        <CButton size="sm" color="danger">Action</CButton>
                        <CButton size="sm" color="warning">Action</CButton>
                        <CButton size="sm" color="info">Action</CButton>
                        <CButton size="sm" color="success">Action</CButton>
                    </CCardFooter>
                </CCard>
            </CCol>
            <CCol md="6">
                <CCard>
                    <CCardHeader>
                        Input Grid for small devices! <small> <code>.col-*</code></small>
                    </CCardHeader>
                    <CCardBody>
                        <CRow
                                class="form-group"
                                v-for="(number, key) in [4,5,6,7,8]"
                                :key="key"
                        >
                            <CCol :col="number">
                                <CInput class="mb-0" :placeholder="`.col-${number}`"/>
                            </CCol>
                            <CCol :col="12 - number">
                                <CInput class="mb-0" :placeholder="`.col-${12 - number}`"/>
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                        <CButton size="sm" color="primary">Action</CButton>
                        <CButton size="sm" color="danger">Action</CButton>
                        <CButton size="sm" color="warning">Action</CButton>
                        <CButton size="sm" color="info">Action</CButton>
                        <CButton size="sm" color="success">Action</CButton>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
        <CRow>
            <CCol lg="12">
                <transition name="fade">
                    <CCard v-if="show">
                        <CCardHeader>
                            <CIcon name="cil-pencil"/> Form Elements
                            <div class="card-header-actions">
                                <CLink href="#" class="card-header-action btn-setting">
                                    <CIcon name="cil-settings"/>
                                </CLink>
                                <CLink
                                        class="card-header-action btn-minimize"
                                        @click="formCollapsed=!formCollapsed"
                                >
                                    <CIcon :name="`cil-chevron-${formCollapsed ? 'bottom' : 'top'}`"/>
                                </CLink>
                                <CLink href="#" class="card-header-action btn-close" v-on:click="show = !show">
                                    <CIcon name="cil-x-circle"/>
                                </CLink>
                            </div>
                        </CCardHeader>
                        <CCollapse :show="formCollapsed">
                            <CCardBody>
                                <CInput
                                        label="Prepended text"
                                        description="Here's some help text"
                                        type="email"
                                        autocomplete="email"
                                        prepend="@"
                                />
                                <CInput
                                        label="Appended text"
                                        append=".00"
                                        description="Here's some help text"
                                />
                                <CInput
                                        label="Appended and prepended text"
                                        append=".00"
                                        description="Here's some help text"
                                        prepend="$"
                                />
                                <CInput
                                        label="Append with button"
                                        description="Here's some help text"
                                >
                                    <template #append>
                                        <CButton color="primary">Go!</CButton>
                                    </template>
                                </CInput>
                                <CInput label="Two-buttons append">
                                    <template #append>
                                        <CButton color="primary">Search</CButton>
                                        <CButton color="danger">Options</CButton>
                                    </template>
                                </CInput>
                                <div class="form-actions">
                                    <CButton type="submit" color="primary">Save changes</CButton>
                                    <CButton color="secondary">Cancel</CButton>
                                </div>
                            </CCardBody>
                        </CCollapse>
                    </CCard>
                </transition>
            </CCol>
        </CRow>



        -->
    </div>
</template>

<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }
    };

    import axios from 'axios';
    import Multiselect from 'vue-multiselect'


    export default {
        components: {
            Multiselect
        },
        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                tags: [],
                cities: ['تهران','کرج','اصفهان','مشهد','اهواز','کاشان'],
                // options: [],
                item: {
                    user_id: '1',
                    code: '',
                    // personal_code: '',
                    image: '',
                    first_name: '',
                    last_name: '',
                    mobile: '',
                    email: '',
                    tell: '',
                    country: '',
                    city: '',
                    address: '',
                    location: '',
                    post_code: '',
                    national_code: '',
                    type: '',
                    state: '',
                    status:'',
                    forecast:'',
                    probability:'',
                    source:'',
                    next_appointment:'',
                    appointment_note:'',
                    tags:[],


                    company:'',
                    brand:'',
                    legal:'',
                    economic_code:'',
                    accounting_code:'',
                    web:'',
                    credit:'',
                    other_info:'',

                },
                errors: [],
                object: Object,
                groups: [],
                loader: false,




                observer: null,
                limit: 10,
                search: '',



                showTrackingItems: false,
                showLegalItems: false,


                // selected: [], // Must be an array reference!
                // show: true,
            //     horizontal: { label:'col-3', input:'col-9' },
            // options: ['Option 1', 'Option 2', 'Option 3'],
            //     selectOptions: [
            //     'Option 1', 'Option 2', 'Option 3',
            //     {
            //         value: ['some value', 'another value'],
            //         label: 'Selected option'
            //     }
            // ],
            //     selectedOption: ['some value', 'another value'],
            //
            //     formCollapsed: true,
            //     checkboxNames: ['Checkboxes', 'Inline Checkboxes',
            //     'Checkboxes - custom', 'Inline Checkboxes - custom'],
            //     radioNames: ['Radios', 'Inline Radios',
            //     'Radios - custom', 'Inline Radios - custom']



            }
        },
        mounted() {
            axios
                .get('/api/contact/tagslist', this.auth)
                .then(response => {

                    for (const key in response.data) {
                        if (response.data.hasOwnProperty(key)) {
                            const element = response.data[key];
                            // console.log(element)

                            this.options.push({
                                title: element.title,
                                id: element.id
                            })
                            // this.details[0].
                        }
                    }
                    this.loader = false
                    // console.log(this.options);

                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)
            axios
                .get('/api/contact/groups', this.auth)
                .then(response => {
                    this.groups = response.data.data;
                    // console.log(this.groups, "44");

                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
                .finally(() => this.loading = false)


            this.observer = new IntersectionObserver(this.infiniteScroll);

        },
        methods: {

            validatorMobile (val) {
                // return val ? val.length >= 11 : null
                // if (val.length !== 11 && val.length > 0)
                if (val){
                    if (val.length !== 11 && val.length > 0)
                        return false
                    else if (val.length === 11)
                        return true
                    else
                        return null
                }

            },
            validatorTell (val) {
                // return val ? val.length >= 11 : null
                // if (val.length !== 11 && val.length > 0)
                if (val){
                    if (val.length >= 8 && val.length > 0)
                        return false
                    else if (val.length >= 8)
                        return true
                    else
                        return null
                }

            },


            disableAppointmentTime (val) {
                // return val ? val.length >= 11 : null
                // if (val.length !== 11 && val.length > 0)
                    if (this.item.status == 2 || this.item.status == 3)
                        return true
                    else
                        return false

            },


            customLabel(option) {
                //   console.log(option.title)

                //   this.item.tags.push(option)
                return `${option.title}`

            },
            pluck(array, key) {
                return array.map(function (obj) {
                    return obj[key];
                });
            },
            saveForm() {
                var app = this;
                var newItem = app.item;
                app.loader = true
                if(newItem.tags.lenght !==0){
                    newItem.tags=this.pluck(newItem.tags,"id")
                }
                axios.post('/api/contacts', newItem, app.auth)
                    .then(function (resp) {
                        app.$snotify.success('آیتم با موفقیت ذخیره ');
                        app.loader = false
                        app.$router.push({
                            // path: '/profile/'+resp.data.data.id
                            path: '/contact/'
                        });
                    })
                    .catch(function (e) {
                        app.loader = false
                        app.errors.push(e.response.data.messages_fa);

                        //                            app.$snotify.warning(e.response.data.message);
                        console.log(e.response.data);


                        for (let value of e.response.data.messages_fa) {
                            //                        for (let error of Object.entries(value[1])) {
                            //                            console.log(app.object.entries(app.errors[0]));

                            app.$snotify.warning(value, {
                                timeout: 7000,
                                //                                    showProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true
                            });

                            //                        }
                        }

                    });
            },


            saveFormAndGoToProfile() {
                var app = this;
                var newItem = app.item;
                app.loader = true
                if(newItem.tags.lenght !==0){
                    newItem.tags=this.pluck(newItem.tags,"id")
                }
                axios.post('/api/contacts', newItem, app.auth)
                    .then(function (resp) {
                        app.$snotify.success('آیتم با موفقیت ذخیره ');

                        // console.log('3434')
                        // console.log(resp)
                        app.loader = false
//                        app.$router.push({
//                            path: '/contacts' ///profile/25
//                        });
                    })
                    .catch(function (e) {
                        app.loader = false
                        app.errors.push(e.response.data.messages_fa);

                        //                            app.$snotify.warning(e.response.data.message);
                        console.log(e.response.data);


                        for (let value of e.response.data.messages_fa) {
                            //                        for (let error of Object.entries(value[1])) {
                            //                            console.log(app.object.entries(app.errors[0]));

                            app.$snotify.warning(value, {
                                timeout: 7000,
                                //                                    showProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true
                            });

                            //                        }
                        }

                    });
            }



        }
    }

</script>


